import english from './en';
import spanish from './es';

export default {
  ...english,
  ...spanish,
};
